<template>
  <a-layout-header class="app-header">
    <div class="header-content">
      <!-- 移动端菜单按钮 -->
      <a-button
        v-if="isMobile"
        type="text"
        class="mobile-menu-button"
        @click="showMobileMenu = true"
      >
        <Menu :size="20" />
      </a-button>
      
      <!-- 移动端当前菜单名称 -->
      <span v-if="isMobile && currentMenuLabel" class="mobile-current-menu">
        {{ currentMenuLabel }}
      </span>
      
      <!-- Logo 区域 -->
      <div class="logo-section">
        <div class="logo-icon">
          <span class="logo-text">P</span>
        </div>
        <h1 class="logo-title">PharmAID</h1>
      </div>
    </div>
    
    <!-- 移动端菜单抽屉 -->
    <a-drawer
      v-model:open="showMobileMenu"
      placement="left"
      :width="280"
      :closable="true"
      class="mobile-menu-drawer"
      :body-style="{ padding: 0 }"
      @close="showMobileMenu = false"
    >
      <template #title>
        <div class="drawer-title">
          <div class="logo-icon">
            <span class="logo-text">P</span>
          </div>
          <span class="drawer-title-text">PharmAID</span>
        </div>
      </template>
      <AppSidebarContent class="mobile-sidebar-content" @menu-click="handleMobileMenuClick" />
    </a-drawer>
  </a-layout-header>
</template>

<script>
import { Menu } from 'lucide-vue-next'
import AppSidebarContent from './AppSidebarContent.vue'
import { isMobileDevice } from '@/utils/deviceDetection'

export default {
  name: 'AppHeader',
  components: {
    Menu,
    AppSidebarContent
  },
  data() {
    return {
      showMobileMenu: false,
      isMobile: false
    }
  },
  created() {
    // 在 created 阶段就检测移动设备，确保初始渲染时就有正确的值
    this.checkMobile()
  },
  computed: {
    currentLabelGroup() {
      return Number(this.$route.params.labelGroup)
    },
    currentMenuLabel() {
      const labelGroupMap = {
        1: '企业/市场端',
        2: '国家政策',
        3: '招投标信息',
        4: '前沿技术',
        5: '器械注册查询',
        6: '临床研究'
      }
      return labelGroupMap[this.currentLabelGroup] || ''
    }
  },
  mounted() {
    this.checkMobile()
    // 确保在 mounted 时立即检查一次
    this.$nextTick(() => {
      this.checkMobile()
    })
    window.addEventListener('resize', this.checkMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = isMobileDevice()
    },
    handleMobileMenuClick() {
      this.showMobileMenu = false
    }
  }
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  padding: 0;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

.header-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 24px;
  gap: 16px;
}

.mobile-menu-button {
  display: none;
  color: rgba(0, 0, 0, 0.85);
  padding: 8px;
  margin-left: -8px;
}

.mobile-current-menu {
  display: none;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.drawer-title-text {
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

/* 移除 drawer-body 的 padding */
:deep(.mobile-menu-drawer .ant-drawer-body),
:deep(.ant-drawer-body) {
  padding: 0 !important;
}

.mobile-sidebar-content {
  height: 100%;
  min-height: calc(100vh - 55px);
}

/* 移动端样式 */
@media (max-width: 767px) {
  .header-content {
    padding: 0 16px;
    gap: 12px;
  }
  
  .mobile-menu-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;
  }
  
  .mobile-current-menu {
    display: block;
  }
  
  .logo-section {
    display: none;
  }
  
  .logo-title {
    font-size: 16px;
  }
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.logo-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
</style>

